import { useQueryClient } from '@tanstack/react-query';
import { getQueryBaseKey } from './getQueryKey';
export const getUseResetInfiniteQuery = (wrapperOptions) => {
    const useResetInfiniteQuery = () => {
        const client = useQueryClient();
        const queryKey = getQueryBaseKey(wrapperOptions, 'infiniteQuery');
        return () => client.resetQueries({ queryKey });
    };
    return useResetInfiniteQuery;
};
